import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {SharedDataService} from "../../../../services/shared/shared-data.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DetailService} from "../../../../services/details/detail.service";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import {PostmessageEditor} from "../../../../models/postmessage-editor.model";
import {Field} from "../../models/field.model";
import * as ThumborUrlBuilder from "thumbor-url-builder";
import {AuthService} from "../../../../services";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'tig-form-editorial-client',
  templateUrl: './form-editorial-client.component.html',
  styleUrls: ['./form-editorial-client.component.scss']
})
export class FormEditorialClientComponent extends Field implements OnInit {

	/**
	 * Attributes
	 */
	public btn_id: string = 'btn_editor_';
	private iframe_ref: BsModalRef;
	public iframe_content: SafeHtml;
	public save_content: SafeHtml = "";
	public static IFRAME_ID = 'iframe-editorial-client';

	route_to_self: string = "";
	// Referenz auf den iFrame im Template
	@ViewChild('modal_iframe', { static: false }) model_iframe;

	// Listen to messages from iframe
	@HostListener('window:message', ['$event'])
	onMessage(event) {
		this.receiveMessageFromIFrame(event);
	}


	/**
	 * @param {SharedDataService} subscription_service
	 * @param {Ng4LoadingSpinnerService} spinner_service
	 * @param detail_service
	 * @param sanitizer
	 * @param toastr_service
	 * @param modal_service
	 * @param helper_service
	 * @param translate_service
	 * @param auth_service
	 * @param activatedRoute
	 */
	constructor(
		private subscription_service: SharedDataService,
		private spinner_service: Ng4LoadingSpinnerService,
		private detail_service: DetailService,
		private sanitizer: DomSanitizer,
		private toastr_service: ToastrService,
		private modal_service: BsModalService,
		private helper_service: HelperService,
		private translate_service: TranslateService,
		private auth_service: AuthService,
		private activatedRoute: ActivatedRoute
	) {
		super();
	}


	/**
	 * Function > ngOnInit
	 */
	ngOnInit(): void {

		// Uebergangstext bis iFrame geladen ist
		this.iframe_content = "<div>Loading...</div>";

		this.btn_id += this.OBJ_field_config.name;

		let params = this.activatedRoute.params;

		this.route_to_self = "/preview-o-"+ params['_value'].id;

	} // end function ngOnInit


	/**
	 * Function > openEditor
	 * @param {HTMLElement} btn
	 */
	openEditor(btn: HTMLElement) {

		// disable button and show the spinner
		btn.setAttribute('disabled', 'disabled');
		this.spinner_service.show();
		this.detail_service.postToIFrame(this.OBJ_field_config._links.iframe.href, this.OBJ_field_config.name).subscribe(
			response => {
				this.iframe_content = this.sanitizer.bypassSecurityTrustHtml(response);
				this.helper_service.logWithClassAndFunction("DetailComponent", "openEditor", "loaded iFrame content", this.iframe_content);
			},
			error => {
				this.toastr_service.error("Could not be loaded");
				// hide spinner
				this.spinner_service.hide();
			},
			() => {
				let modal_options = new ModalOptions();
				modal_options.ignoreBackdropClick = true;
				modal_options.class = 'tig-modal';

				this.iframe_ref = this.modal_service.show(this.model_iframe, modal_options);
				btn.removeAttribute('disabled');

				// hide spinner
				this.spinner_service.hide();

			});

	} // end function openEditor

	/**
	 * Function > closeEditorWithoutSaving
	 */
	closeEditorWithoutSaving() {
		this.iframe_ref.hide();
	}


	closeEditorWithSaving() {

		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormEditorialClientComponent.IFRAME_ID) as HTMLIFrameElement;

		// Request data from iFrame
		let msg =
			{
				"data": {
					"event": "save_request"
				}
			};

		// send message to iFrame that we want its data
		iframeEl.contentWindow.postMessage(msg, "*");

	}


	/**
	 * Function > changeIframe
	 * @param iframe
	 * @param {string} class_name
	 * @return void
	 */
	changeIframe(iframe, class_name: string): void {

		if (iframe.className == class_name) {
			iframe.className = 'tig-default';
		}
		else {
			iframe.className = class_name;
		} // end if

	} // end function changeIframe


	/**
	 * Function > receiveMessageFromIFrame
	 * @return void
	 * @param event
	 */
	receiveMessageFromIFrame(event): void {

		let target = window.location.origin;
		this.helper_service.logWithClassAndFunction(
			"DetailComponent", "receiveMessageFromIFrame", [{ "Accepted origin": target }]
		);

		// accept only events of certain origin
		if (event.data.iframe && event.origin == target) {

			let data: PostmessageEditor = event.data;

			switch (data.event)
			{
				case 'save':
					// fill value field with edited HTML
					this.OBJ_field_config.value = data.data;

					// Fuer alle weiteren uebergebenen Daten loese ein Event aus, auf das entsprechende Felder reagieren koennen
					Object.keys(data.additional_data).forEach(
						key => {
							// Gib weiteren Feldern ueber geupdatete Werte Bescheid
							this.subscription_service.sendValue(key + "_external", data.additional_data[key]);
						});

					this.markAsDirtyAndTouched();

					// close iframe
					this.iframe_ref.hide();
					break;
				case 'upload':
					// upload image and send message to iframe
					let form_data = new FormData();
					form_data.append('upload', data.data.upload);
					form_data.append('json', JSON.stringify(data.data.json));
					this.detail_service.post('/api/images', form_data).subscribe(
						(response: any) => {

							response.success = true;
							// Baue URL des Bildes zusammen
							let thumbor_url_builder = new ThumborUrlBuilder("infinity", response.server);
							response.url = "https://" + thumbor_url_builder.
							setImagePath(response.folderprefix +
								response.folder +
								response.filename +
								"." + response.ext).
							buildUrl();
							event.source.postMessage(response, event.origin);
							this.helper_service.log({ class: "DetailComponent", function: "receiveMessageFromIFrame", uploadFile: response });
						},
						(error) => {
							event.source.postMessage({ success: false }, event.origin);
							// output saving failed
							this.toastr_service.error(this.translate_service.instant("oUpload.sFailed"));
						},
						() => {
							// output saving successfully
							this.toastr_service.success(this.translate_service.instant("oUpload.sSuccessfully"));
						});
					break;
				case 'generate_hash':
					let hash = this.helper_service.generateHash(data.params, data.body, this.auth_service.getToken("access_token"));
					// Post data to iFrame
					event.source.postMessage(hash, event.origin);
					break;
			}

		} // end if

	} // end function receiveMessageFromIFrame


	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormEditorialClientComponent.IFRAME_ID;
	} // end function getIFrameID

}
